import React, { useState } from "react";
import { ReactComponent as LogoIcon } from "../../assets/logo.svg";
import { ReactComponent as MobileLogoIcon } from "../../assets/MobileLogoIcon.svg";
import { ReactComponent as UserIcon } from "../../assets/User.svg";
import { ReactComponent as SearchIcon } from "../../assets/Search.svg";
import { Link, useNavigate } from "react-router-dom";
import "./nav.css";
import { useDisclosure } from "@mantine/hooks";
import { Burger, Modal } from "@mantine/core";
import { Menu, Button, Text } from "@mantine/core";
import {
  IconSettings,
  IconSearch,
  IconPhoto,
  IconMessageCircle,
  IconTrash,
  IconArrowsLeftRight,
  IconChevronDown,
  IconPlaneDeparture,
  IconLogout,
  IconPlaneTilt,
} from "@tabler/icons-react";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Reducers/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";

const Nav = ({ totalMessageCount = 0 }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [opened, { toggle }] = useDisclosure();

  const [logoutModalOpened, { open, close }] = useDisclosure(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [flightScheduleSubmenuOpen, setFlightScheduleSubmenuOpen] =
    useState(false);

  const handle403error = (err) => {
    if (err) {
      if (err.response) {
        if (
          Number(err?.response?.status) === 403 ||
          Number(err?.response?.status) === 401
        ) {
          setTimeout(() => {
            console.log("Unauthorized or forbidden. Logging out.");
            dispatch(logout());
            // localStorage.clear();
            localStorage.setItem("from_403_status", "call_toast");
            navigate("/login");
            // toast.warn("Session Expired");
            toast.success("Token Expired");
          }, 1000);
        }
      }
    }
  };

  const handleLogOut = async () => {
    try {
      const token = localStorage.getItem("client_token");

      if (!token) {
        console.log("No token found, logging out anyway.");
      } else {
        await axios.get(`${base_url.api1}/users/logout`, {
          headers: {
            Authorization: `JWT ${token}`,
            // Authorization: `JWT eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzQzNzQyNDQ2LCJpYXQiOjE3NDM0ODMyNDYsImp0aSI6IjY2MWY0MDllNDU3ZjQxOTFhMTE1M2JlODMzMTBkNGVkIiwidXNlcm5hbWUiOjExfQ.BrGQAzmRdh-g9bC2zRawvW_D3r2O_kxYYMVr1r-Xx1E`,
          },
        });
      }
      dispatch(logout());
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      handle403error(error);
    }
  };

  const handleSettingsClick = () => {
    console.log("Settings clicked");
    navigate("/account-settings");
    // Add your settings logic here
  };

  const handleMyClaimClick = () => {
    console.log("my claim clicked");
    navigate("/dashboard");
  };

  const handleMessagesClick = () => {
    console.log("Messages clicked");
    navigate("/dashboard");

    // Add your messages logic here
  };

  const handleLogoutClick = () => {
    console.log("Logout clicked");
    handleLogOut();
    // Add your logout logic here
  };

  const handleSearchClick = () => {
    console.log("Search clicked");
    // Add your search logic here
  };

  const handleDeleteAccountClick = () => {
    console.log("Delete account clicked");
    // Add your delete account logic here
  };

  const { user } = useSelector((state) => state.user);

  return (
    <div>
      <Modal
        opened={logoutModalOpened}
        onClose={close}
        centered
        radius={"lg"}
        size={"md"}
        withCloseButton={false}
      >
        <div className="logout-modal-wrapper">
          {/* <CircleTickIcon /> */}
          <h5 className="logout-text">Are you sure want to logout ?</h5>

          <div className="logout-btn-wrapper">
            <CustomButton
              style={{ width: "50%" }}
              btnText={"Cancel"}
              flex={1}
              onClick={close}
              type="secondary"
            />

            <CustomButton
              style={{ width: "50%" }}
              btnText={"Logout"}
              flex={1}
              onClick={handleLogoutClick}
              type="danger"
            />
          </div>
        </div>
      </Modal>
      <ToastContainer />
      <div className="nav">
        <Link to={"/"}>
          <LogoIcon />
        </Link>
        <div className="menu-container">
          <Link to={"/"}>Home</Link>
          <Link to={"/start-your-claim"}>File a claim</Link>
            <Link to={"/claimstatus"}>Claim Status</Link>

          {/* {!user ? (
            <Link to={"/claimstatus"}>Claim Status</Link>
          ) : (
            <Link to={"/dashboard"}>Claim Status</Link>
          )} */}

          <Link to={"/historic-data"} onClick={() => {
             localStorage.removeItem('flightFormData');
            localStorage.removeItem('airportFormData');
            localStorage.removeItem('airlineFormData');
             localStorage.removeItem('searchMethod');
            localStorage.removeItem('flightData');
             localStorage.removeItem('flightDataRoute');
          }}>Flight Schedule & Live Tracking</Link>
          {/* <Link to={"/flight-tracking"}>Flight Live Tracking</Link> */}
          {/* <Link to={"/check-weather"}>Check Weather</Link> */}

          <Link to={"/about-us"}>About us</Link>
          <Link to={"/faq"}>FAQs</Link>
          <Link to={"/contact-us"}>Contact us</Link>
        </div>
        {/* <div className="navicon-wrapper">
          <span>
            <SearchIcon />
          </span>

          {!user ? (
            <span
              onClick={() => navigate("/login")}
              style={{ cursor: "pointer" }}
            >
              <UserIcon />
            </span>
          ) : (
            <Menu
              shadow="md"
              width={200}
              styles={{ dropdown: { borderRadius: "12px" } }}
            >
              <Menu.Target>
                <span style={{ cursor: "pointer" }}>
                  <UserIcon />
                </span>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconArrowsLeftRight size={20} color="#314064" />
                  }
                  onClick={handleMyClaimClick}
                  className="popup-links"
                >
                  My claims
                </Menu.Item>

                <Menu.Item
                  leftSection={<IconSettings size={20} color="#314064" />}
                  onClick={handleSettingsClick}
                  className="popup-links"
                >
                  Settings
                </Menu.Item>

                <Menu.Divider />

                <Menu.Label>Danger zone</Menu.Label>
                <Menu.Item
                  // color="red"
                  leftSection={<IconTrash size={20} color="#D04244" />}
                  onClick={open}
                  className="popup-links"
                >
                  Logout
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          )}
        </div> */}
      </div>

      {/* Mobile Menu */}
      {/* <div className="mobile-nav" style={{ backgroundColor: opened ? "#ffffff" : "transparent" }}> */}
      <div className={`mobile-nav ${opened ? "bg-white" : ""}`}>
        <div className="mobile-nav-logo-container">
          <span className="mobile-icon-wrapper">
            <Burger opened={opened} onClick={toggle} size={"sm"} />
          </span>
          <Link to={"/"}>
            <MobileLogoIcon />
          </Link>
        </div>

        {opened && (
          <div className="mobile-nav-links">
            <Link to={"/"}>Home</Link>
            <Link to={"/start-your-claim"}>File a claim</Link>
            <Link to={"/claimstatus"}>Claim Status</Link>
            {/* {!user ? (
              <Link to={"/claimstatus"}>Claim Status</Link>
            ) : (
              <Link to={"/dashboard"}>Claim Status</Link>
            )} */}

            <Link to={"/historic-data"} onClick={() => {
             localStorage.removeItem('flightFormData');
              localStorage.removeItem('airportFormData');
              localStorage.removeItem('airlineFormData');
              
             localStorage.removeItem('searchMethod');
            localStorage.removeItem('flightData');
             localStorage.removeItem('flightDataRoute');
          }}>Flight Schedule & Live Tracking</Link>
            {/* <Link to={"/flight-tracking"}>Flight Live Tracking</Link> */}

            {/* <Link to={"/check-weather"}>Check Weather</Link> */}
            <Link to={"/about-us"}>About us</Link>
            <Link to={"/faq"}>FAQs</Link>
            <Link to={"/contact-us"}>Contact us</Link>
          </div>
        )}

        {/* <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span className="mobile-icon-wrapper">
            <SearchIcon />
          </span>
          {!user ? (
            <span
              onClick={() => navigate("/login")}
              className="mobile-icon-wrapper"
            >
              <UserIcon />
            </span>
          ) : (
            <Menu
              shadow="md"
              width={200}
              styles={{ dropdown: { borderRadius: "12px" } }}
            >
              <Menu.Target>
                <span className="mobile-icon-wrapper">
                  <UserIcon />
                </span>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconArrowsLeftRight size={20} color="#314064" />
                  }
                  onClick={handleMyClaimClick}
                  className="popup-links"
                >
                  My claims
                </Menu.Item>
                <Menu.Item
                  leftSection={<IconSettings size={20} color="#314064" />}
                  onClick={handleSettingsClick}
                  className="popup-links"
                >
                  Settings
                </Menu.Item>

                <Menu.Divider />

                <Menu.Label>Danger zone</Menu.Label>
                <Menu.Item
                 
                  leftSection={<IconTrash size={20} color="#D04244" />}
                  onClick={open}
                  className="popup-links"
                >
                  Logout
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default Nav;
